/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationClassificationFilter extends models.RecommendationFilterBase {
    getFixupPrototypeFunction() { return RecommendationClassificationFilter.fixupPrototype; }

    static newInstance(model: Partial<RecommendationClassificationFilter>): RecommendationClassificationFilter {
        let obj = Object.assign(new RecommendationClassificationFilter(), model);
        RecommendationClassificationFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationClassificationFilter>): RecommendationClassificationFilter {
        if (!model) return null;
        return RecommendationClassificationFilter.newInstance(<RecommendationClassificationFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationClassificationFilter) {
        if (!obj) return;

        models.RecommendationClassificationFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationClassificationFilter): boolean {
        if (models.RecommendationFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationClassificationFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of Policy Classifications
     */
    policy_classifications: Array<models.PolicyClassification>;

    /**
     * List of Policy Sub Classifications
     */
    policy_sub_classifications: Array<models.PolicySubClassification>;

}
